<template>
  <Chip
    :removable="closable"
    class="bg-primary-50 py-1 text-xs font-medium text-primary-700"
    @remove="$emit('close')"
  >
    <slot />
  </Chip>
</template>

<script setup>
import Chip from 'primevue/chip';

defineProps({
  closable: { type: Boolean, default: true },
});

defineEmits(['close']);
</script>
